//自定义组件
import List from "../components/common/List";
import Detail from "../components/common/Detail";
import myTab from "../components/common/myTab";
import lyTime from "../components/common/lyTime";
import Top from "../components/common/top";
import lyFormItem from "../components/common/lyFormItem";

function plugins(Vue) {
  Vue.component("List", List);
  Vue.component("Detail", Detail);
  Vue.component("myTab", myTab);
  Vue.component("lyTime", lyTime);
  Vue.component("Top", Top);
  Vue.component("lyFormItem", lyFormItem);
}

export default plugins;



// WEBPACK FOOTER //
// ./src/util/plugins.js